import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import detailsPage from './productDetailsReducer';

const productDetailsReducers = combineReducers({
  detailsPage,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
const store = createStore(productDetailsReducers, composeEnhancers(applyMiddleware(thunk)));

export default store;
